import { createContext } from 'react';

export type OpenHelpWindow = (
  title: string,
  text: string,
  meta: { analytics: { helpKey: any } }
) => void;

const HelpWindowContext = createContext<OpenHelpWindow>(() => null);

HelpWindowContext.displayName = 'HelpWindowContext';

export default HelpWindowContext;
